// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAC6HW-xrufF0XqY1QuATjAPyiiRq33KLM",
  authDomain: "popout-nyc-firebase.firebaseapp.com",
  projectId: "popout-nyc-firebase",
  storageBucket: "popout-nyc-firebase.firebasestorage.app",
  messagingSenderId: "165610777771",
  appId: "1:165610777771:web:46172a53101292ab1cdbee",
  measurementId: "G-HV21X2YPGC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };
export default app;
